import React, { useEffect, useState } from "react";
import { isNullOrUndefined } from "util";
import * as tools_api from "../../services/api/tools";
import { toLocateNumber } from "../../utils/format";
import SelectBase from "./SelectBase";

const SelectSand: React.FC<SelectType<SandValues>> = props => {
  const [items, setItems] = useState<SandValues[]>([]);

  useEffect(() => {
    getItems();
  }, []);

  const getItems = () => {
    tools_api.getSands().then(({ data }) => setItems(data));
  };

  const options = () => {
    return items.map(item => ({
      value: item.id,
      label: `${item.number} | ${toLocateNumber(
        item.density,
        3,
        0,
        "",
        "g/cm³"
      )}`
    }));
  };

  const onChange = (value: any) => {
    let item = value;
    if (!isNullOrUndefined(value) && props.onChange) {
      item = items.filter(c => c.id === value)[0];
      props.onChange(item);
    } else {
      props.onChange(undefined);
    }
  };

  return (
    <SelectBase
      {...props}
      placeholder="Areia..."
      newItem={props.newItem}
      updatedItem={props.updatedItem}
      deletedItem={props.deletedItem}
      getItems={getItems}
      options={options()}
      onClick={onChange}
    />
  );
};

export default SelectSand;
